<template>
  <div class="installments-reports">
    <div class="d-flex justify-content-between align-items-center flex-wrap">
      <h3>تقرير الاقساط للوحدات</h3>

      <div>
        <h6>فلتر بالمدة الزمنية</h6>
        <!-- <el-date-picker
          @change="getReport"
          v-model="value1"
          type="datetimerange"
          range-separator="الي"
        >
        </el-date-picker> -->

        <el-date-picker
          style="width: 100%"
          @change="getReport"
          v-model="dateRange"
          type="daterange"
          range-separator="الي"
          format="yyyy/MM/dd"
          value-format="yyyy-MM-dd"
          start-placeholder="بداية الفترة"
          end-placeholder="نهاية الفترة"
          class="display-mobile-none"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          class="filter-mobile"
          format="yyyy/MM/dd"
          value-format="yyyy-MM-dd"
          @change="getReport"
          v-model="startDate"
          placeholder="بداية الفترة"
        />
        <el-date-picker
          type="date"
          class="filter-mobile"
          format="yyyy/MM/dd"
          value-format="yyyy-MM-dd"
          @change="getReport"
          v-model="endDate"
          placeholder="نهاية الفترة"
        />
      </div>
    </div>

    <div class="report-stats d-flex gap-4">
      <div>
        <h6>إجمالي الاقساط</h6>
        <span> {{ totalInstallments.toLocaleString("en-US") }} </span>
      </div>
      <div>
        <h6>المدفوع</h6>
        <span> {{ totalPaied.toLocaleString("en-US") }} </span>
      </div>
      <div>
        <h6>المتبقي</h6>
        <span>
          {{ (totalInstallments - totalPaied).toLocaleString("en-US") }}
        </span>
      </div>
    </div>

    <div class="d-flex gap-2 flex-row-reverse">
      <el-select placeholder="حدد المشروع" v-model="project_id">
        <el-option value="عرض الكل">الكل</el-option>
        <el-option
          v-for="item in projects"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          @change="filterInInstallments"
        >
        </el-option>
      </el-select>
      <el-select v-model="filterdData" placeholder="حالة القسط">
        <el-option
          v-for="(item, index) in [
            { name: 'الكل', val: 'all' },
            { name: 'دفع جزئي', val: 'part' },
            { name: 'لم يتم السداد', val: 'not' },
            { name: ' تم السداد', val: 'done' },
          ]"
          :key="index"
          :label="item.name"
          :value="item.val"
          @change="filterInInstallments"
        >
        </el-option>
      </el-select>
    </div>

    <el-table :data="filterInInstallments" class="report-table table-mobile">
      <el-table-column prop="project_unit.client.name" label="العميل">
        <template slot-scope="scope">
          <span class="label">{{ scope.$index + 1 }} # العميل</span>
          <div>{{ scope.row.project_unit.client.name }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="project_unit.description" label="اسم الوحدة">
        <template slot-scope="scope">
          <span class="label">اسم الوحدة</span>
          <div>{{ scope.row.project_unit.description }}</div>
        </template>
      </el-table-column>
      <el-table-column label="قيمة الاقساط">
        <template slot-scope="scope">
          <span class="label">قيمة الاقساط</span>
          <div>{{ scope.row.amount.toLocaleString("en-US") }}</div>
        </template>
      </el-table-column>

      <el-table-column label="المدفوع">
        <template slot-scope="scope">
          <span class="label">المدفوع</span>
          <div>{{ scope.row.paied.toLocaleString("en-US") }}</div>
        </template>
      </el-table-column>
      <el-table-column label="المتبقي">
        <template slot-scope="scope">
          <span class="label">المتبقي</span>
          <div>
            {{ (scope.row.amount - scope.row.paied).toLocaleString("en-US") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="paied_at" label="تاريخ السداد">
        <template slot-scope="scope">
          <span class="label">تاريخ السداد</span>
          <div>{{ scope.row.paied_at }}</div>
        </template>
      </el-table-column>
      <el-table-column label="الحالة">
        <template slot-scope="scope">
          <span class="label">الحالة</span>
          <div>
            <h6
              style="color: orange"
              v-if="scope.row.paied > 0 && scope.row.paied != scope.row.amount"
            >
              دفع جزئي
            </h6>
            <h6 style="color: red" v-else-if="scope.row.paied == 0">
              لم يتم السداد
            </h6>
            <h6
              style="color: green"
              v-else-if="scope.row.paied == scope.row.amount"
            >
              تم السداد
            </h6>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import axiosApi from "../plugins/axios";
export default {
  data() {
    return {
      projects: [],
      dateRange: null,
      project_id: null,
      value1: "",
      reports: [],
      totalInstallments: 0,
      totalPaied: 0,
      filterdData: "all",
      startDate: "",
      endDate: "",
    };
  },
  computed: {
    filterInInstallments() {
      console.log("reports length ", this.reports.length);
      let x = this.reports.filter((ele) => {
        if (this.filterdData == "all") {
          return true;
        } else if (this.filterdData == "done") {
          return ele.paied == ele.amount;
        } else if (this.filterdData == "part") {
          return ele.paied > 0 && ele.paied != ele.amount;
        } else {
          return ele.paied == 0;
        }
      });
      console.log("x length ", x.length);

      if (this.project_id > 0) {
        x = x.filter((installment) => {
          console.log(installment.project_unit["project_id"], this.project_id);
          return installment.project_unit["project_id"] == this.project_id;
        });
      }

      this.totalInstallments = x.reduce(
        (prev, curr) => {
          return { amount: +prev.amount + +curr.amount };
        },
        { amount: 0 }
      ).amount;

      this.totalPaied = x.reduce(
        (prev, curr) => {
          return { paied: +prev.paied + +curr.paied };
        },
        { paied: 0 }
      ).paied;
      return x;
    },
  },
  mounted() {
    this.getReport();
    this.getProjects();
  },
  methods: {
    getProjects() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get("/projects")
        .then((res) => {
          this.projects = res.data;
        })
        .finally(() => loading.close());
    },
    getReport() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      let params = {};
      if (this.dateRange) {
        params.start = this.dateRange[0];
        params.end = this.dateRange[1];
      }
      if (this.startDate) {
        params.start = this.startDate;
      }
      if (this.endDate) {
        params.end = this.endDate;
      }
      if (this.project_id) {
        params.project_id = this.project_id;
      }
      axiosApi
        .get(`/unit_installments`, { params })
        .then((res) => {
          this.reports = res.data;
          this.totalInstallments = res.data.reduce(
            (prev, curr) => {
              return { amount: +prev.amount + +curr.amount };
            },
            { amount: 0 }
          ).amount;

          this.totalPaied = res.data.reduce(
            (prev, curr) => {
              return { paied: +prev.paied + +curr.paied };
            },
            { paied: 0 }
          ).paied;
          // this.totalResidual = res.data.amount.reduce((prev, curr) => {return +prev + +curr} , 0)
          //      {{ totalInstallments }}
          // {{ totalPaied }}
          // {{ totalResidual }}
        })
        .finally(() => loading.close());
    },
  },
};
</script>
<style lang="scss">
.installments-reports {
  padding: 15px;

  .report-table {
    margin-top: 15px;
    td,
    tr {
      padding: 15px !important;
      @media (max-width: 575px) {
        padding: 0px !important;
      }
    }
  }

  .report-stats {
    > div {
      padding: 15px;
      background: #fff;
      margin: 15px 0;
      text-align: center !important;
      border-radius: 10px;
      min-width: 160px;
      h6 {
        text-align: center !important;
        font-weight: bold;
      }
    }
  }
}
</style>
